import "./ContactUs.module.css";
import Header from "@/reusable_sections/Header";
import ContactDetailsMap from "./sections/ContactDetailsMap";
import Footer from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <Header />
      <ContactDetailsMap />
      <div className="w-full max-w-4xl mx-auto px-4 py-12">
        <iframe src="https://form.jotform.com/260233181041038" className="w-full min-h-[600px] border-0" title="Contact Form" allowFullScreen />
      </div>
      <Footer />
    </div>;
}